/**
 * Données livret interactif Permis AM (BSR) - 8 h sur 2 journées.
 * 6 chapitres cochés : Bienvenue · Ma moto · J1 Découvrir · J2 Conduire ·
 * Circulation · Prêt.
 */
import { Sparkles, Bike, Shield, Route, Flag, Trophy } from 'lucide-react';

export const LIVRET_AM = {
  storageKey: 'code2roues:livret-am:v1',
  title: 'Livret Permis AM',
  subtitle: '8 h · Dès 14 ans · BSR',
  trameTo: '/permis-am',
  trameLabel: 'Hub Permis AM · Formation complète',
  livretTo: '/livret-am',
  livretLabel: 'Livret Permis AM interactif',
  chapters: [
    {
      id: 'cover',
      n: '',
      title: 'Bienvenue dans ta formation AM',
      icon: Sparkles,
      color: '#e11d48',
      intro: 'Ce livret t\u2019accompagne pendant tes 8 heures de formation Permis AM (BSR). Coche les cases au fur et à mesure avec ton moniteur, ou en révision à la maison.',
      profil: true,
      sections: [
        {
          title: 'Ce que tu vas apprendre',
          items: [
            'Découvrir ton scooter ou ta moto 50 cm³',
            'Maîtriser les bases de la conduite',
            'Circuler en sécurité sur route',
            'Anticiper les dangers de la route',
            'Devenir un vrai conducteur responsable',
          ],
        },
      ],
    },
    {
      id: 'mon-vehicule',
      n: '01',
      title: 'Mon véhicule & mon équipement',
      icon: Shield,
      color: '#f59e0b',
      context: 'salle',
      sections: [
        {
          title: 'Équipement obligatoire',
          items: [
            'Je porte un casque homologué correctement attaché',
            'Je porte des gants moto',
            'Je porte un blouson qui protège mes bras',
            'Je porte des chaussures fermées qui protègent mes chevilles',
            'Je sais pourquoi chaque équipement est important',
          ],
        },
        {
          title: 'Mon deux-roues',
          items: [
            'Je connais toutes les commandes de mon 2-roues',
            'Je sais faire mes vérifications avant de partir (pneus, freins, éclairage)',
            'Je sais mettre / enlever ma béquille',
            'Je sais démarrer et couper mon moteur',
          ],
        },
      ],
    },
    {
      id: 'journee-1',
      n: '02',
      title: 'Journée 1 · Tu découvres ta moto',
      icon: Bike,
      color: '#16a34a',
      context: 'plateau',
      sections: [
        {
          title: 'Premières sensations',
          items: [
            'Je peux garder mon équilibre à basse vitesse',
            'Je sais accompagner ma moto en marchant à côté',
            'Je sais démarrer en douceur, sans à-coup',
            'Je regarde loin devant moi (pas mes pieds)',
          ],
        },
        {
          title: 'Manœuvres de base',
          items: [
            'Je sais tourner à gauche et à droite',
            'Je sais faire un slalom autour de plots',
            'Je sais freiner avec les 2 freins',
            'Je sais m\u2019arrêter précisément à un endroit demandé',
          ],
        },
      ],
    },
    {
      id: 'journee-2',
      n: '03',
      title: 'Journée 2 · Tu deviens conducteur',
      icon: Route,
      color: '#0891b2',
      context: 'plateau',
      sections: [
        {
          title: 'Maîtrise avancée',
          items: [
            'Je sais réaliser un demi-tour',
            'Je sais faire un freinage d\u2019urgence sans blocage',
            'Je sais éviter un obstacle (regard vers la sortie)',
            'Je sais rouler en gardant une allure régulière',
          ],
        },
        {
          title: 'Regard et anticipation',
          items: [
            'Je regarde loin pour anticiper',
            'Je regarde derrière moi avant de changer de direction',
            'Je pense aux angles morts des voitures',
          ],
        },
      ],
    },
    {
      id: 'circulation',
      n: '04',
      title: 'Sur la route',
      icon: Flag,
      color: '#ea580c',
      context: 'circulation',
      sections: [
        {
          title: 'Je sais me placer',
          items: [
            'Je me place au bon endroit sur la voie',
            'Je garde mes distances de sécurité',
            'Je respecte les limitations et la signalisation',
          ],
        },
        {
          title: 'Je sais réagir',
          items: [
            'Je cède la priorité quand c\u2019est nécessaire',
            'Je sais franchir un rond-point',
            'Je sais tourner à gauche ou à droite en sécurité',
            'Je fais toujours mon contrôle d\u2019angle mort',
          ],
        },
        {
          title: 'Je fais attention aux autres',
          items: [
            'Je pense aux piétons (surtout les enfants et les personnes âgées)',
            'Je pense aux cyclistes',
            'Je pense aux voitures et aux camions',
          ],
        },
      ],
    },
    {
      id: 'pret',
      n: '05',
      title: 'Prêt à rouler seul ?',
      icon: Trophy,
      color: '#a855f7',
      sections: [
        {
          title: 'Mon auto-évaluation',
          items: [
            'Je me sens à l\u2019aise sur ma moto',
            'Je maîtrise mon freinage',
            'Je gère les intersections sans stress',
            'Je regarde loin et j\u2019anticipe',
            'Je connais mes limites',
            'Je suis prêt à rouler seul en toute sécurité',
            'Je m\u2019engage à toujours mettre mon équipement',
          ],
        },
      ],
    },
  ],
};
